import { useMutation } from '@tanstack/react-query'
import { jobDescriptionApi } from '@/services/jobDescriptions/jobDescriptions'

interface SendInvitationParams {
  inviteeUserId: string
  targetUserId: string
  surveyId: string
}

export const useSendInvitation = () => {
  return useMutation({
    mutationFn: (payload: SendInvitationParams) => jobDescriptionApi.sendInvitation(payload),
  })
}
